import { render, staticRenderFns } from "./DuelsControls.vue?vue&type=template&id=d50dd4fe&scoped=true"
import script from "./DuelsControls.vue?vue&type=script&lang=js"
export * from "./DuelsControls.vue?vue&type=script&lang=js"
import style0 from "./DuelsControls.vue?vue&type=style&index=0&id=d50dd4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50dd4fe",
  null
  
)

export default component.exports